import React from 'react';
import { Tabs } from '@components';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  HISTORICO_RENDA_MENSAL_ABSOLUTE_PATH,
  PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
} from '../../../common/utils/paths';

export const PercentualRecebimentoRendaPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = () => {
    if (location.pathname.includes('percentualRecebimentoRendaMensal'))
      return 'Alterar Percentual de Recebimento Renda';
    if (location.pathname.includes('historicoPercentualRecebimentoRendaMensal'))
      return 'Histórico de Intenção de Percentual de Troca de Recebimento Mensal';
    return 'Percentual de Contribuição';
  };

  return (
    <>
      <Helmet>
        <title>Forluz - Percentual de Recebimento Renda</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-32 mb-md-5">
        Percentual de Recebimento Renda
      </h1>
      <Tabs active={activeTab}>
        <div
          label="Alterar Percentual de Recebimento Renda"
          onClick={() => navigate(PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH)}
          aria-hidden
        >
          <Outlet />
        </div>
        <div
          label="Histórico de Intenção de Percentual de Troca de Recebimento Mensal"
          onClick={() => navigate(HISTORICO_RENDA_MENSAL_ABSOLUTE_PATH)}
          aria-hidden
        >
          <Outlet />
        </div>
      </Tabs>
    </>
  );
};
